import React from 'react';
import PropTypes from 'prop-types';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

// Same editor family as the patient portal's impersonation editor, so both
// write the same kind of HTML into accounts.PatientData.
const TOOLS = [
  { label: 'B', title: 'Bold', run: (e) => e.chain().focus().toggleBold().run(), active: 'bold', style: { fontWeight: 700 } },
  { label: 'I', title: 'Italic', run: (e) => e.chain().focus().toggleItalic().run(), active: 'italic', style: { fontStyle: 'italic' } },
  { label: '• List', title: 'Bullet list', run: (e) => e.chain().focus().toggleBulletList().run(), active: 'bulletList' },
  { label: '1. List', title: 'Numbered list', run: (e) => e.chain().focus().toggleOrderedList().run(), active: 'orderedList' },
];

// The initial content is set once; remount with a new `key` to load other text.
const RichTextEditor = ({ initialValue, onChange }) => {
  const editor = useEditor({
    extensions: [StarterKit],
    content: initialValue || '',
    onUpdate: ({ editor: e }) => onChange(e.getHTML()),
    // Keeps the toolbar's active state in step with the cursor.
    shouldRerenderOnTransaction: true,
  });

  if (!editor) return null;
  return (
    <div className="rte">
      <div className="rte-toolbar">
        {TOOLS.map((tool) => (
          <button
            key={tool.title}
            type="button"
            title={tool.title}
            className={`rte-btn ${editor.isActive(tool.active) ? 'active' : ''}`}
            style={tool.style}
            onClick={() => tool.run(editor)}
          >
            {tool.label}
          </button>
        ))}
      </div>
      <EditorContent editor={editor} className="review-rich-editor" />
    </div>
  );
};

RichTextEditor.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default RichTextEditor;
